import { defineNuxtRouteMiddleware } from '#app/composables/router'
import { useUser } from '#storefront/composables'
import { useMurId } from '~/composables/useMurId'

export default defineNuxtRouteMiddleware(async () => {
  const { user } = await useUser({
    key: 'mur-id-middleware',
  })

  // Only proceed if we have a valid user
  if (!user.value || user.value.status?.isGuestCustomer) {
    return
  }

  // Get murId and wait for it to be fetched
  const { murId, getMurId } = useMurId({ user: user.value })

  // Fetch murId immediately and block rendering until complete
  if (!murId.value) {
    try {
      await getMurId()
    } catch (error) {
      console.error('Error fetching murId in middleware:', error)
    }
  }
})
